import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Constants, SessionStorageService } from '../_services';

@Component({
  selector: 'app-header-dash',
  templateUrl: 'header-dash.component.html'
})
export class HeaderDashComponent implements OnInit {
  @Input()
  SiteName: string;
  @Input()
  LogoImage: string;
  @Input()
  LogoImageAlt: string;
  @Input()
  WelcomeGreetingFormat: string;
  @Input()
  EnglishLanguageLabel: string;
  @Input()
  FrenchLanguageLabel: string;
  @Input()
  SkipToMainContentText: string;
  @Input()
  SkipToNavigationMenuText: string;

  altLanguageLabel: string;
  welcomeGreeting: string = '';
  isMediaSmallAndUp: boolean;

  constructor(private sessionState: SessionStorageService) {
    this.evaluateMediaWidth();
  }

  ngOnInit(): void {
    const altLanguageCode = this.sessionState.getAltLanguageCode();
    if (altLanguageCode === Constants.LanguageCodeEnglish) {
      this.altLanguageLabel = this.EnglishLanguageLabel;
    } else if (altLanguageCode === Constants.LanguageCodeFrench) {
      this.altLanguageLabel = this.FrenchLanguageLabel;
    } else {
      throw new Error(`Unhandled case - ${altLanguageCode}`);
    }

    const userFullName: string | null = this.sessionState.getUserFullName();
    if (userFullName) {
      const indexOfToken = this.WelcomeGreetingFormat.indexOf('${user}');
      if (indexOfToken >= 0) {
        // replace all occurences (case-sensitive)
        this.welcomeGreeting = this.WelcomeGreetingFormat.replace(/\$\{user\}/g, userFullName);
      } else {
        this.welcomeGreeting = `${this.WelcomeGreetingFormat} ${userFullName}`;
      }
    }
  }

  toggleLanguage(): void {
    event.preventDefault();

    this.sessionState.toggleCurrentLanguageCode();
  }

  skipToMainContent(event: Event): void {
    event.preventDefault();

    const elMain = document.getElementById('dash-wrapper');
    if (elMain != null) {
      elMain.scrollIntoView({ behavior: 'instant', block: 'start' });
      elMain.focus();
    }
  }

  skipToNavigationMenu(event: Event): void {
    event.preventDefault();

    const elHamburgerMenuToggle = document.getElementById('nav-link-toggle');
    if (elHamburgerMenuToggle != null) {
      elHamburgerMenuToggle.focus();
      elHamburgerMenuToggle.click();
    }
  }

  @HostListener('window:resize')
  private evaluateMediaWidth(): boolean {
    this.isMediaSmallAndUp = window.innerWidth >= 576;
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/global/header-dash.component.ts